import { render, staticRenderFns } from "./ShiftsEstimatesRe.vue?vue&type=template&id=87fe3ec6&lang=pug"
import script from "./ShiftsEstimatesRe.vue?vue&type=script&lang=js"
export * from "./ShiftsEstimatesRe.vue?vue&type=script&lang=js"
import style0 from "./ShiftsEstimatesRe.vue?vue&type=style&index=0&id=87fe3ec6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports